"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trialBalanceQuerySchema = exports.accountLedgerQuerySchema = void 0;
/**
 * Request contracts for General Ledger inquiry / Trial Balance (Stage
 * 13, Milestone 1) — read-only query parameters, not body payloads.
 */
const zod_1 = require("zod");
exports.accountLedgerQuerySchema = zod_1.z.object({
    from: zod_1.z.coerce.date().optional(),
    to: zod_1.z.coerce.date().optional(),
});
exports.trialBalanceQuerySchema = zod_1.z.object({
    asOfDate: zod_1.z.coerce.date(),
    fromDate: zod_1.z.coerce.date().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    costCenterId: zod_1.z.string().uuid().optional(),
    profitCenterId: zod_1.z.string().uuid().optional(),
});
//# sourceMappingURL=financial-general-ledger.request.js.map